import {useFormInputLabelWithSuffix} from '@hconnect/common/hooks'
import {EquipmentPlain, EquipmentIdType} from '@hconnect/common/types'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {COMMON_SHIFT_EVENT_WIDGET_NAMESPACE} from '../../consts'

import {EquipmentSearchHierarchy} from './EquipmentSearchHierarchy'

type Props = {
  errorText?: React.ReactNode
  onChange: (equipment: EquipmentPlain | undefined) => void
  plantId: string
  value: EquipmentPlain | undefined
  required?: boolean
  disabled?: boolean
  mainEquipmentId?: string
  idType?: EquipmentIdType
}

export const EventEquipmentSearchHierarchy = (props: Props) => {
  const {t} = useTranslation(COMMON_SHIFT_EVENT_WIDGET_NAMESPACE)

  const label = useFormInputLabelWithSuffix({
    label: t('shiftEvent.label.functionalLocation'),
    optional: !props.required,
    optionalTKey: t('shiftEvent.label.optional')
  })

  return <EquipmentSearchHierarchy label={label} {...props} />
}
